import { MedicalInsuredFormRow } from '../types';
import { AmendmentPolicyPerson } from '../types/getAmendmentPolicyPersonsResponse.types';

const buildAddressText = (person: AmendmentPolicyPerson) => {
  if (!person.personAddress) {
    return '';
  }

  return [
    person.personAddress.address?.building,
    person.personAddress.address?.street,
    person.personAddress.zone?.title,
    person.personAddress.address?.city,
    person.personAddress.country?.title
  ]
    .filter(Boolean)
    .join(', ');
};

const formatGrApplicable = (value: string | boolean | null | undefined) => {
  if (value === true || value === 'YES') {
    return 'YES';
  }

  if (value === false || value === 'NO') {
    return 'NO';
  }

  return value ? String(value) : '';
};

export const mapAmendmentPolicyPersonsToMedicalInsureds = (
  policyPersons: AmendmentPolicyPerson[] | undefined | null
): MedicalInsuredFormRow[] => {
  const medicalInsuredPersons = (policyPersons ?? []).filter(
    (person) => person.isPrincipal !== null
  );

  if (medicalInsuredPersons.length === 0) {
    return [];
  }

  const mapped = medicalInsuredPersons.map((person) => ({
    insuredID: person.personID || '',
    isPrincipal: person.isPrincipal || false,
    relation: person.relation || (person.isPrincipal ? 'Principal' : ''),
    addressID: person.personAddressID || '',
    addressDetails: buildAddressText(person),
    cardNumber: person.cardNumber || '',
    dateOfBirth: person.person?.dateOfBirth || '',
    passportNumber: person.person?.passportNumber || '',
    continuity: person.continuity || '',
    tpaReference1: person.tpaReference1 || '',
    tpaReference2: person.tpaReference2 || '',
    grApplicable: formatGrApplicable(person.grApplicable),
    exclusions: person.exclusions || '',
    remarks: person.remarks || '',
    isNew: person.isNew || false,
    isRemoved: person.isRemoved || false,
    personType: person.person?.type || ''
  }));

  mapped.sort((a, b) => {
    if (a.isPrincipal && !b.isPrincipal) return -1;
    if (!a.isPrincipal && b.isPrincipal) return 1;

    return 0;
  });

  return mapped;
};
